<template>
  <div class="row">
    <div class="">
      <div class="card h-100 pb-3">
        <div class="card-header pb-0 p-3">
          <div class="">
            <div class="row col-6 d-flex align-items-center">
              <div class="text-center text-primary my-2 loader" v-if="loading">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <!-- <h6 class="mb-0">{{ loading ? "Loading..." : "" }}</h6> -->
            </div>
            <div class="row border-bottom">
              <div class="col-12 d-flex pb-3">
                <h6 class="mb-0">CALENDAR</h6>
              </div>
            </div>
            <div class="row border-bottom">
              <div class="col-12 d-flex py-2">
                <button
                  class="btn btn-primary btn-sm btn-task mb-0 ms-auto"
                  @click="onAddNew()"
                >
                  Add Activity
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body p-3 d-flex flex-column">
          <FullCalendar ref="fullCalendar" :options="calendarOptions" />

          <b-modal
            id="event-modal-view"
            tabindex="-1"
            aria-labelledby="delete_modal_label"
            aria-hidden="true"
            hide-footer
            @hide="onHide"
          >
            <template #modal-header>
              <h6 class="text-center mb-0">ACTIVITY</h6>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                :disabled="loadingAction"
                @click="$bvModal.hide('event-modal-view')"
              ></button>
            </template>

            <div class="d-grid gap-2 d-md-block text-start" v-if="eventDetail">
              <div v-if="loadingAction">
                <div
                  class="
                    text-center
                    d-flex
                    justify-content-center
                    py-3
                    align-items-center
                  "
                  style="min-height: 638.76px"
                >
                  <b-spinner class="mx-auto"></b-spinner>
                </div>
              </div>

              <form
                v-if="!loadingAction"
                @submit.prevent="onSubmit"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                />

                <div class="row">
                  <div class="col-12">
                    <div
                      class="d-flex align-items-center container-fluid p-0 pb-3"
                    >
                      <input
                        placeholder="Title"
                        class="form-control"
                        type="text"
                        v-if="eventDetail"
                        v-model="eventDetail.title"
                        required
                      />
                    </div>
                    <div
                      v-if="
                        submitted &&
                        eventDetail &&
                        (eventDetail.title === '' || !eventDetail.title)
                      "
                      class="invalid-tooltip d-block"
                    >
                      This field is required.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <input
                      type="datetime-local"
                      class="form-control mb-3"
                      :class="
                        submitted &&
                        eventDetail.start &&
                        eventDetail.end &&
                        eventDetail.start > eventDetail.end
                          ? 'is-invalid'
                          : ''
                      "
                      v-model="eventDetail.start"
                    />
                    <div
                      v-if="
                        submitted &&
                        (eventDetail.start === '' || !eventDetail.start)
                      "
                      class="invalid-tooltip"
                    >
                      This field is required.
                    </div>

                    <div
                      v-if="
                        submitted &&
                        eventDetail.start &&
                        eventDetail.end &&
                        eventDetail.start > eventDetail.end
                      "
                      class="invalid-tooltip"
                    >
                      Start date must greater than end date.
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <input
                      type="datetime-local"
                      class="form-control"
                      :class="
                        submitted &&
                        eventDetail.start &&
                        eventDetail.end &&
                        eventDetail.start > eventDetail.end
                          ? 'is-invalid'
                          : ''
                      "
                      v-model="eventDetail.end"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-list-group>
                      <b-list-group-item
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                        v-for="(participant, index) in eventDetail.participants"
                        :key="index"
                      >
                        {{ participant.email }}
                        <a
                          class="
                            btn btn-link
                            text-danger text-gradient
                            px-3
                            mb-0
                          "
                          href="javascript:;"
                          @click="deleteParticipant(participant)"
                          ><i
                            class="far fa-trash-alt me-2"
                            aria-hidden="true"
                          ></i
                          >Delete</a
                        >
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </div>
                <p></p>
                <div class="row">
                  <div class="col-12">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <v-select
                        class="w-100 me-3"
                        v-model="selectedParticipant"
                        :options="paginated"
                        :filterable="false"
                        @open="onOpen"
                        @close="onClose"
                        @search="(query) => (search = query)"
                        placeholder="Add contacts"
                      ></v-select>
                      <button
                        class="btn btn-primary btn-sm waves-effect waves-light"
                        type="button"
                        name="delete_participant"
                        value="11"
                        @click="addParticipant()"
                        :disabled="loadingAction"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
                <p></p>
                <label for="legal_entity_id">Legal Entity*</label>
                <v-select
                  v-model.trim="legal_entity"
                  :options="legalEntityList"
                ></v-select>
                <p></p>
                <VueEditor
                  v-model="eventDetail.description"
                  v-if="eventDetail"
                />
                <div
                  v-if="
                    submitted &&
                    (eventDetail.description === '' || !eventDetail.description)
                  "
                  class="invalid-tooltip"
                >
                  This field is required.
                </div>
                <p></p>
                <div class="text-center">
                  <div class="d-flex flex-row">
                    <button
                      class="btn btn-danger btn-sm waves-effect waves-light"
                      type="button"
                      name="delete_event"
                      value="11"
                      @click="deleteEvent()"
                      v-if="!isAdd"
                      :disabled="loadingAction"
                    >
                      Delete Event
                    </button>
                    <button
                      class="
                        btn btn-primary btn-sm
                        ms-auto
                        waves-effect waves-light
                      "
                      type="button"
                      name="delete_opportunity"
                      value="11"
                      :disabled="loadingAction"
                      @click="onSubmit()"
                    >
                      Save
                    </button>
                    <button
                      class="
                        btn btn-outline-primary btn-sm
                        ms-2
                        waves-effect waves-light
                      "
                      type="button"
                      :disabled="loadingAction"
                      data-bs-dismiss="modal"
                      @click="$bvModal.hide('event-modal-view')"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { activitiyService } from '../services/activities.service'
import { VueEditor } from 'vue2-editor'
import moment from 'moment'
import { utilService } from '../services/util.service'

export default {
  name: 'Activities',
  components: {
    FullCalendar,
    VueEditor
  },
  data () {
    return {
      loading: true,
      loadingAction: false,
      eventDetail: null,
      events: [],
      selectedParticipant: null,
      listParticipants: [],
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        events: [],
        eventClick: this.showEvent
      },
      userInfor: null,
      isAdd: true,
      submitted: false,
      observer: null,
      limit: 10,
      deletedEventId: '',
      search: '',
      listDropdown: [],
      legal_entity: ''
    }
  },
  computed: {
    filtered () {
      return this.listDropdown
        .filter((e) => {
          return e.email.includes(this.search)
        })
        .sort((a, b) => a.label.localeCompare(b.label))
    },
    paginated () {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage () {
      return this.paginated.length < this.filtered.length
    },
    legalEntityList () {
      return utilService.currentListOrgsValue || []
    }
  },
  created () {
    this.userInfor = utilService.userInforValue
    if (utilService.currentListParticipantsValue) {
      this.listParticipants = utilService.currentListParticipantsValue.map(
        (e) => {
          e.label = e.email
          e.code = e.id
          return e
        }
      )
      this.listDropdown = this.listParticipants
    }
    activitiyService.getData().then((rs) => {
      rs.forEach((event) => {
        const evt = {
          title: event.title,
          data: event,
          date: event.start,
          id: event.id
        }
        this.events.push(evt)
      })
      this.$nextTick(() => {
        if (this.$refs.fullCalendar) {
          this.$refs.fullCalendar.getApi().addEventSource(this.events)
        }
        this.loading = false
      })
    })
    this.observer = new IntersectionObserver(this.infiniteScroll)
  },
  methods: {
    moment,
    async onOpen () {
      if (this.hasNextPage) {
        await this.$nextTick()
        // this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    async infiniteScroll ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.limit += 10
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    onSubmit () {
      const isEdit = this.eventDetail.id
      this.submitted = true
      if (
        this.eventDetail.description === '' ||
        this.eventDetail.title === '' ||
        this.eventDetail.start === '' ||
        new Date(this.eventDetail.start).getTime() >
          new Date(this.eventDetail.end).getTime()
      ) {
        return
      }
      const payload = JSON.parse(JSON.stringify(this.eventDetail))
      payload.start = parseInt(moment(payload.start).format('X'))
      if (payload.end) {
        payload.end = parseInt(moment(payload.end).format('X'))
      }
      this.loadingAction = true
      payload.calendar_id = this.userInfor.profile.nylas_default_calendar
      if (payload.end === '' || !payload.end) {
        payload.end = payload.start
      }
      if (isEdit) {
        activitiyService.updateData(payload, this.eventDetail.id).then((rs) => {
          this.$bvModal.hide('event-modal-view')
          const evt = {
            title: rs.title,
            data: rs,
            date: rs.start,
            id: rs.id,
            ...rs
          }
          evt.date = evt.date.substring(0, evt.date.length - 8)
          this.events = this.events.map((e) => {
            if (e.id === evt.id) {
              e = evt
            }
            return e
          })
          if (this.$refs.fullCalendar) {
            this.$refs.fullCalendar.getApi().removeAllEventSources()
            this.$refs.fullCalendar.getApi().addEventSource(this.events)
          }
          this.loadingAction = false
          this.submitted = false
          this.$forceUpdate()
        })
      } else {
        activitiyService.addData(payload).then((rs) => {
          setTimeout(() => {
            this.$bvModal.hide('event-modal-view')
          }, 0)
          const evt = {
            title: rs.title,
            data: rs,
            date: rs.start,
            id: rs.id,
            ...rs
          }
          evt.date = evt.date.substring(0, evt.date.length - 8)
          this.events.push(evt)
          if (this.$refs.fullCalendar) {
            this.$refs.fullCalendar.getApi().removeAllEventSources()
            this.$refs.fullCalendar.getApi().addEventSource(this.events)
          }
          this.submitted = false
          this.loadingAction = false
          this.$forceUpdate()
        })
      }
    },
    deleteParticipant (par) {
      this.eventDetail.participants = this.eventDetail.participants.filter(
        (e) => e.email !== par.email
      )

      par.label = par.email
      par.code = par.id
      this.listDropdown.push(par)
      this.$forceUpdate()
    },
    deleteEvent () {
      const id = this.eventDetail.id
      const event = this.$refs.fullCalendar.getApi().getEventById(id)
      this.loadingAction = true
      activitiyService.deleteData(id).then((rs) => {
        this.$bvModal.hide('event-modal-view')
        if (event) {
          event.remove()
        }
        this.loadingAction = false
      })
    },
    onAddNew () {
      this.isAdd = true
      this.$bvModal.show('event-modal-view')
      this.eventDetail = {}
    },
    onHide () {
      this.eventDetail = null
      this.loadingAction = false
    },
    showEvent (calendar) {
      this.isAdd = false
      this.eventDetail = calendar.event.extendedProps.data
      this.eventDetail.description = this.eventDetail.description.trim()
      this.deletedEventId = calendar.event.id

      setTimeout(() => {
        if (this.eventDetail && this.eventDetail.participants.length > 0) {
          this.listDropdown = this.listDropdown.filter(
            (e) =>
              !this.eventDetail.participants.find((b) => b.email === e.email)
          )
        }
        this.$bvModal.show('event-modal-view')
      }, 0)
    },
    addParticipant () {
      if (!this.eventDetail.participants) {
        this.eventDetail.participants = []
      }
      this.eventDetail.participants.push(this.selectedParticipant)
      this.listDropdown = this.listDropdown.filter(
        (e) => e.email !== this.selectedParticipant.email
      )
      this.selectedParticipant = null
    },
    isValid () {
      return (
        new Date(this.eventDetail.start).getTime() <
        new Date(this.eventDetail.end).getTime()
      )
    }
  }
}
</script>

<style scoped>
.loader {
  position: absolute;
  width: 99%;
  height: 100%;
  background: #fff;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  border-radius: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Activities.vue